<template>
	<div>
		<validation-observer ref="observer" v-slot="{ handleSubmit }">
			<b-form v-on:submit.stop.prevent="handleSubmit( onSubmit )">
				<b-form-row>
					<b-col md="10">
						<b-form-row>
							<b-col md="9">
								<validation-provider v-slot="validationContext" name="Prize Description" v-bind:rules="{ required: true }" vid="description">
									<b-form-input id="prize-description" v-model="prize.description" placeholder="Prize Description" tabindex="0" v-bind:state="getValidationState( validationContext )"></b-form-input>
									<b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
								</validation-provider>
							</b-col>
							<b-col md="3">
								<validation-provider v-slot="validationContext" name="Prize Quantity" v-bind:rules="{ required: true, min_value: 1 }" vid="quantity">
									<b-form-input id="prize-quantity" v-model.number="prize.quantity" placeholder="##" type="number" v-bind:state="getValidationState( validationContext )"></b-form-input>
									<b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
								</validation-provider>
							</b-col>
							<b-col md="12">
								<validation-provider v-slot="validationContext" :rules="{ required: true }" name="Prize Importance" vid="importance">
									<b-form-radio-group id="prize-importance" v-model="prize.importance" :state="getValidationState( validationContext )" name="importance">
										<b-form-radio value="high">High</b-form-radio>
										<b-form-radio value="medium">Medium</b-form-radio>
										<b-form-radio value="low">Low</b-form-radio>
										<b-form-invalid-feedback :state="getValidationState( validationContext )">
											{{ validationContext.errors[0] }}
										</b-form-invalid-feedback>
									</b-form-radio-group>
								</validation-provider>
							</b-col>
						</b-form-row>
					</b-col>
					<b-col md="2">
						<b-button :disabled="project.locked" block type="submit" variant="light">Add</b-button>
					</b-col>
				</b-form-row>
			</b-form>
		</validation-observer>
		<hr class="bg-primary"/>
		<b-list-group>
			<b-list-group-item>
				<h4 class="text-right"><strong>Total:</strong> {{ total }}</h4>
			</b-list-group-item>
			<b-list-group-item v-for="n in prizes" :key="n.id" class="pl-0 pr-0">
				<prize-tile :value="n"></prize-tile>
			</b-list-group-item>
		</b-list-group>

	</div>
</template>

<script>
import { PROJECT_PRIZES_ADD, PROJECT_PRIZES_FETCH } from '../../store/actions/project'
import PrizeTile from '../../components/PrizeTile'

export default {
	name: 'ProjectPrizes',
	components: { PrizeTile },
	props: ['id'],

	computed: {
		project: function () { return this.$store.state.project.project },
		prizes: function () { return this.$store.state.project.prizes },
		total: function () { return Intl.NumberFormat().format(this.prizes.reduce((a, b) => a + b.quantity, 0)) }
	},

	data () {
		return {
			prize: {
				description: '',
				quantity: 0,
				importance: ''
			}
		}
	},

	methods: {
		getValidationState ({ dirty, validated, valid = null }) {
			return dirty || validated ? valid : null
		},

		async onSubmit () {
			this.$refs['observer'].reset()
			this.prize.project = JSON.parse(JSON.stringify(this.project))

			this.$axios.post(`/prizes`, this.prize)
				.then(response => {
					this.prize.description = ''
					this.prize.quantity = 0
					this.prize.project = null
					this.$store.commit(PROJECT_PRIZES_ADD, response.data)
					this.$bvToast.toast('Your prize has been added!', {
						title: 'Success!',
						autoHideDelay: 5000,
						variant: 'success'
					})
				})
		},

		fetchPrizes () {
			this.$store.dispatch(PROJECT_PRIZES_FETCH, this.project.id)
		}
	},

	mounted () {
		if (this.project.id) {
			this.fetchPrizes()
		}
	},

	watch: {
		project: function () { this.fetchPrizes() }
	}
}
</script>
